<template>
  <base-button type="submit" class="btn-primary" text="ログイン" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'LoginButton',
  components: {
    BaseButton,
  },
}
</script>
